import { render, staticRenderFns } from "./CorrosionMonitoring.vue?vue&type=template&id=7927984e&scoped=true&"
import script from "./CorrosionMonitoring.vue?vue&type=script&lang=js&"
export * from "./CorrosionMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7927984e",
  null
  
)

export default component.exports